/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import PropTypes from "prop-types";
import React from "react";
import { useEffect } from "react";
import { BarChartContainer, Border } from "./style";
import VerticalBarChart from "./VerticalBarChart";
import { ImageUrl } from "../../../utils/constants";
import { commaSeperator } from '../../../utils/methods';


const BarChart = ({
  

  heading = "Top Performing Managers | Overall",
  total = 0,
  totalText = totalText || "Total Recognition",
  data = [],
  imageKey = "image",
  countKey = "total_recognitions",
  id = 1,
  circleColor,
  circleBorderColor,
  barColor,
  widthType = "half",
  style,
  labelType,
  labelKey,
  type
}) => {
  useEffect(() => {}, []);

  const graphRender = (data) => {
    const topActivities = data.map((item, answerIndex) => ({
      y: Math.round(item[countKey]),
      color: getColorByIndex(answerIndex), // You can define getColorByIndex function
      image: ImageUrl + "/" + item[imageKey],
    }));
    // const xAxisLabels = data.map((answer) => ImageUrl + "/" + answer[imageKey]);
    const xAxisLabels = data.map((answer) => {
      const imagePath = answer[imageKey];
      return {
        imagePath: ImageUrl + "/" + imagePath,
        fullName: labelKey ? answer[labelKey] : answer.full_name,
      };
    });

    const maxValue = Math.max(...topActivities.map((activity) => activity.y));
    

    const getTickInterval = (max) => {
      if (max <= 4) return 1;
      if (max <= 10) return 2;
      const roughInterval = max / 4;
      const magnitude = Math.pow(10, Math.floor(Math.log10(roughInterval)));
      return Math.ceil(roughInterval / magnitude) * magnitude;
    };
    
    const tickInterval = maxValue ? getTickInterval(maxValue) : 25;
    const yAxisLabels = ["25%", "50%", "75%", "100%"];
    const dataValue = [
      {
        name: "",
        data: topActivities,
        showInLegend: false,
        color: "#DE9444",
      },
    ];
    return (
      <div className="bargraph" style={{ ...style }}>
        <VerticalBarChart
          id={`${id} ${1}`}
          seriesData={dataValue}
          xAxisLabel={xAxisLabels}
          yAxisVisible={yAxisLabels}
          fillColor={1}
          cultureSurvey={1}
          width={"8px"}
          circleColor={circleColor}
          circleBorderColor={circleBorderColor}
          barColor={barColor}
          widthType={widthType}
          dataLength={data.length}
          maxValue={maxValue}
          tickInterval={tickInterval}
          labelType={labelType}
          type={type}
        />
      </div>
    );
  };

  function getColorByIndex(index) {
    // Define an array of colors or generate colors dynamically
    const colors = ["rgba(128, 213, 152, 1)"];

    // Return the color based on the index, repeating if necessary
    return colors[index % colors.length];
  }
  return (
    <>
      <BarChartContainer background={type==="fitness"&&"transparent"} id="bar-chart-container" style={{ ...style }}>
        <div id="heading" className="heading">{heading}</div>
        {type!=="fitness"?<Border />:null}

        {total >= 0 && data.length !== 0 ? (
          <>
            {type!=="fitness"?<div id="total-row" className="total-row">
              <span id="total" className="total">{commaSeperator(total)}</span>
              <span id="total-text" className="total-text">{totalText}</span>
            </div>:null}
            <div>{graphRender(data, id || total)}</div>
          </>
        ) : (
          <span id="no-data-fount" className="no-data">No Data Found</span>
        )}
      </BarChartContainer>
    </>
  );
};

BarChart.propTypes = {
  heading: PropTypes.string,
  total: PropTypes.number,
  totalText: PropTypes.string,
  data: PropTypes.array,
  widthType: PropTypes.string,
  id: PropTypes.any,
  imageKey: PropTypes.string,
  countKey: PropTypes.string,
  circleColor: PropTypes.string,
  circleBorderColor: PropTypes.string,
  barColor: PropTypes.string,
  style: PropTypes.object,
  labelType: PropTypes.string,
  labelKey:PropTypes.string,
  type:PropTypes.string
};

export default BarChart;

